import React, { useState, ChangeEvent, MouseEvent } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import NavbarComponent from "./NavbarComponent";
import LoginComponent from "./LoginComponent";
import FooterComponent from "./FooterComponent";

interface QrState {
    whatever_text: string;
    qrimg: string;
}

const GuestQrcodeComponent: React.FC = () => {
    const [state, setState] = useState<QrState>({
        whatever_text: "",
        qrimg: "",
    });
    const { whatever_text, qrimg } = state;

    const inputValue = (name: keyof QrState) => (event: ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, [name]: event.target.value });
    };

    const sendQrCode = (e: MouseEvent<HTMLInputElement>) => {
        e.preventDefault();

        axios
        .get(`${process.env.REACT_APP_API}guest/returnqrcode?text=${whatever_text}`,
            {
                headers: {
                    Authorization: `Bearer `
                }
            }
        )
        .then(response => {
            setState({ ...state, whatever_text: whatever_text, qrimg: response.data.return });
        }).catch(err => {
            Swal.fire(
                "Error",
                err.response ? err.response.data.error : "Error",
                "error",
            );
        });
    };

    return (
        <div className="d-flex h-100 bg-dark">
            <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column text-center text-white min-h-max">
                <NavbarComponent />
                <div className="container p-5">
                    <main className="px-3">
                        <div className="row">
                            <label htmlFor="text" className="col-3 col-form-label">Whataver Text: </label>
                            <div className="col-6">
                                <input type="text" className="form-control" name="text" id="text" value={whatever_text} onChange={inputValue("whatever_text")} />
                            </div>
                            <div className="col-3">
                                <input type="submit" className="btn btn-info" id="genqrcode" value="Generate" onClick={sendQrCode} />
                            </div>
                        </div>
                        <div className="row mt-5">
                            <label htmlFor="qrcode" className="col-3 col-form-label">QRCode : </label>
                            <div id="qrcode" className="col-9 col-form-label text-start">
                                {qrimg && <img src={qrimg} alt="Generated QRCode" />}
                            </div>
                        </div>
                        {qrimg && (
                            <div className="row mt-5">
                                <div className="col-md-3"></div>
                                <div className="col-md-6 text-left d-grid" id="btn-container">
                                    <a href={qrimg} download={'Qrcode_' + whatever_text + '.png'} className='btn btn-block btn-success'>Export / Download</a>
                                </div>
                                <div className="col-md-6"></div>
                            </div>
                        )}
                    </main>
                </div>
                <FooterComponent />
            </div>
            <LoginComponent />
        </div>
    );
};

export default GuestQrcodeComponent;
